/**
 * PumaMesh wordmark + leaping-puma-through-binary motif. In production the official
 * mark from pumamesh.com (/assets/images/...) should be dropped in place of this
 * inline SVG placeholder so the portal uses the real asset, not a recreation. §8
 */
export function Brand({ compact = false }: { compact?: boolean }) {
  return (
    <div className="flex items-center gap-3">
      <span className="relative inline-flex h-9 w-9 items-center justify-center rounded-sm border border-accent/40 bg-accent/10">
        <svg viewBox="0 0 24 24" className="h-5 w-5 text-accent-strong" fill="none" aria-hidden>
          <path
            d="M3 17c3-1 4-4 6-6s5-4 9-5c-1 3-2 5-4 7-2.5 2.5-5 3.5-8 4l-1 3-2-1 0-6z"
            fill="currentColor"
            opacity="0.9"
          />
          <circle cx="17" cy="7" r="0.9" fill="#081119" />
        </svg>
      </span>
      {!compact && (
        <div className="leading-tight">
          <div className="font-semibold tracking-tight text-ink">
            Puma<span className="text-accent-strong">Mesh</span>
          </div>
          <div className="font-mono text-[10px] uppercase tracking-[0.2em] text-ink-dim">
            Customer Portal
          </div>
        </div>
      )}
    </div>
  );
}
